<app-btn-nuevo-propiedad *appRole="['Propiedades.Crear']"></app-btn-nuevo-propiedad>
<br>
<br>
<mat-card *appRole="['Propiedades.Ver']">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-lg-2">
        <mat-form-field class="example-full-width">
          <ngx-spinner [zIndex]="100" name="spBusquedaEstadosPropiedad" bdColor="rgba(255,255,255,0.8)" size="small"
            color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
          <mat-label>Estado propiedad</mat-label>
          <mat-select placeholder="Seleccione opción" multiple formControlName="EstadosPropiedad">
            <mat-option [value]="item.id" *ngFor="let item of lstEstadosContrato; trackBy: trackByItems">
              {{ item.descripcion | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-2">
        <mat-form-field class="example-full-width">
          <ngx-spinner [zIndex]="100" name="spBusquedaTiposPropiedad" bdColor="rgba(255,255,255,0.8)" size="small"
            color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
          <mat-label>Tipos propiedad</mat-label>
          <mat-select placeholder="Seleccione opción" multiple formControlName="TiposPropiedad">
            <mat-option [value]="item.id" *ngFor="let item of lstTiposPropiedad; trackBy: trackByItems">
              {{ item.descripcion | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-2">
        <mat-form-field class="example-full-width">
          <ngx-spinner [zIndex]="100" name="spBusquedaPropiedadClase" bdColor="rgba(255,255,255,0.8)" size="small"
            color="#009688" type="line-scale" [fullScreen]="false"></ngx-spinner>
          <mat-label>Clase propiedad</mat-label>
          <mat-select placeholder="Seleccione opción" multiple formControlName="ClasesPropiedad">
            <mat-option [value]="item.id" *ngFor="let item of lstPropiedadClase; trackBy: trackByItems">
              {{ item.descripcion | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-3">
        <mat-form-field class="full-width">
          <mat-label>Fecha creación</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [disabled]="true" formControlName="FechaAltaDesde" placeholder="Fecha desde">
            <input matEndDate [disabled]="true" formControlName="FechaAltaHasta" placeholder="Fecha hasta">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
        </mat-form-field>
      </div>
      <div class="col-lg-1 d-flex align-items-center">
        <mat-checkbox formControlName="Activo">Activo</mat-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-2">
        <button mat-stroked-button color="primary" (click)="filtrarPropiedades()">
          <mat-icon>filter_alt</mat-icon>
          Filtrar
        </button>
      </div>
    </div>
  </form>

  <ngx-spinner name="spListadoPropiedad" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom"
    [fullScreen]="false">
  </ngx-spinner>
  <div class="row" *ngIf="dataSource.data.length >= 1">
    <div class="col-lg-2">
      <mat-form-field>
        <input matInput class="form-field" [formControl]="ubicacionFilter" placeholder="Filtro Ubicación">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-lg-2">
      <mat-form-field>
        <input matInput class="form-field" [formControl]="localidadFilter" placeholder="Filtro Localidad">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <!-- Barra de acciones masivas: aparece sólo cuando hay filas seleccionadas -->
  <div class="acciones-masivas" *ngIf="selection.selected.length > 0">
    <span class="acciones-masivas-info">
      <mat-icon>checklist</mat-icon>
      {{ selection.selected.length }} propiedad{{ selection.selected.length > 1 ? 'es' : '' }} seleccionada{{ selection.selected.length > 1 ? 's' : '' }}
    </span>

    <span class="acciones-masivas-botones">
      <button mat-stroked-button color="primary" (click)="actualizarNotificarRecibo(true)"
        matTooltip="Al emitir un recibo de estas propiedades se enviará una copia oculta a los correos configurados en Parámetros del Sistema.">
        <mat-icon>mark_email_read</mat-icon>
        Activar aviso por mail
      </button>

      <button mat-stroked-button color="warn" (click)="actualizarNotificarRecibo(false)">
        <mat-icon>unsubscribe</mat-icon>
        Desactivar aviso
      </button>

      <button mat-button (click)="selection.clear()">
        Cancelar
      </button>
    </span>
  </div>

  <div class="tabla-container">
    <table mat-table [dataSource]="dataSource" [hidden]=!data matSort matSortStart="asc" class="mat-elevation-z8"
      full-width>

      <!-- Columna de selección múltiple -->
      <ng-container matColumnDef="seleccion">
        <mat-header-cell *matHeaderCellDef class="seleccion-cell">
          <mat-checkbox (change)="masterToggle()"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            matTooltip="Seleccionar todas">
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad" class="seleccion-cell">
          <mat-checkbox (click)="$event.stopPropagation()"
            (change)="selection.toggle(propiedad)"
            [checked]="selection.isSelected(propiedad)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- Columna Aviso por mail al emitir recibo -->
      <ng-container matColumnDef="notificarRecibo">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          Aviso recibo
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <mat-icon *ngIf="propiedad.notificarRecibo" color="primary"
            matTooltip="Al emitir un recibo de esta propiedad se avisa por mail">mark_email_read</mat-icon>
          <mat-icon *ngIf="!propiedad.notificarRecibo" class="icono-inactivo"
            matTooltip="Sin aviso por mail">remove</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- Columna Ubicación -->
      <ng-container matColumnDef="ubicacion">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          Ubicación
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad" class="ubicacion-cell">
          <div class="ubicacion-info">
            <div class="direccion-principal" *ngIf="propiedad.ubicacion; else sinUbicacion">
              <strong>{{ propiedad.ubicacion | uppercase }}</strong>
              <span *ngIf="propiedad.piso" class="detalle-ubicacion">
                Piso: {{ propiedad.piso | uppercase }}
              </span>
              <span *ngIf="propiedad.departamento" class="detalle-ubicacion">
                Depto: {{ propiedad.departamento | uppercase }}
              </span>
            </div>
            <ng-template #sinUbicacion>
              <span class="sin-datos">
                <mat-icon>location_off</mat-icon>
                Sin ubicación
              </span>
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Columna Propietario -->
      <ng-container matColumnDef="propietario">
        <mat-header-cell *matHeaderCellDef class="header-cell">
          Propietarios
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad" class="propietarios-cell">
          <div class="propietarios-container" *ngIf="propiedad?.propietario?.length > 0; else noPropietarios">
            <mat-chip-list class="propietarios-chips">
              <mat-chip *ngFor="let prop of propiedad.propietario;" class="propietario-chip" color="primary" selected>
                <mat-icon matChipAvatar>person</mat-icon>
                {{ prop.descripcion | titlecase }}
              </mat-chip>
            </mat-chip-list>
          </div>
          <ng-template #noPropietarios>
            <div class="sin-datos">
              <mat-icon>person_off</mat-icon>
              Sin propietarios
            </div>
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Columna Localidad -->
      <ng-container matColumnDef="localidad">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          Localidad
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span *ngIf="propiedad.localidad?.descripcion; else sinLocalidad">
            {{ propiedad.localidad.descripcion | titlecase }}
          </span>
          <ng-template #sinLocalidad>
            <span class="sin-datos">Sin localidad</span>
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Columna Tipo Propiedad -->
      <ng-container matColumnDef="tipoPropiedad">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          Tipo
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span *ngIf="propiedad.tipoPropiedad?.descripcion; else sinTipo">
            {{ propiedad.tipoPropiedad.descripcion | titlecase }}
          </span>
          <ng-template #sinTipo>
            <span class="sin-datos">Sin tipo</span>
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Columna Clase Propiedad -->
      <ng-container matColumnDef="propiedadClase">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          Clase
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span *ngIf="propiedad.propiedadClase?.descripcion; else sinClase">
            {{ propiedad.propiedadClase.descripcion | titlecase }}
          </span>
          <ng-template #sinClase>
            <span class="sin-datos">Sin clase</span>
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Columna Estado -->
      <ng-container matColumnDef="estadoPropiedad">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          Estado
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span class="estado-badge" [ngClass]="{
                    'estado-con-contrato': propiedad.estadoPropiedad.id === estadosPropiedadEnum.ConContrato,
                    'estado-sin-contrato': propiedad.estadoPropiedad.id === estadosPropiedadEnum.SinContrato
                  }">
            {{ propiedad.estadoPropiedad?.descripcion || 'Sin estado' }}
          </span>
        </mat-cell>
      </ng-container>

      <!-- Columna Fecha Alta -->
      <ng-container matColumnDef="fechaAlta">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          Fecha Alta
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span class="fecha-badge">{{ propiedad.fechaAlta | date:'dd/MM/yyyy' }}</span>
        </mat-cell>
      </ng-container>

      <!-- Columna Activo -->
      <ng-container matColumnDef="activo">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">
          Activo
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad">
          <span class="activo-badge" [ngClass]="{
                    'activo-si': propiedad.activo,
                    'activo-no': !propiedad.activo
                  }">
            <mat-icon>{{ propiedad.activo ? 'check_circle' : 'cancel' }}</mat-icon>
            {{ propiedad.activo ? 'Sí' : 'No' }}
          </span>
        </mat-cell>
      </ng-container>

      <!-- Columna Acciones -->
      <ng-container matColumnDef="accion">
        <mat-header-cell *matHeaderCellDef class="header-cell">
          Acciones
        </mat-header-cell>
        <mat-cell *matCellDef="let propiedad" class="acciones-cell">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menú de acciones" class="menu-button">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <!-- Ver primero: es lo que se hace la mayoría de las veces -->
            <button *appRole="['Propiedades.Ver']" mat-menu-item [routerLink]="['/propiedades/ver', propiedad.id]">
              <mat-icon color="primary">visibility</mat-icon>
              <span>Ver</span>
            </button>
            <button *appRole="['Propiedades.Modificar']" mat-menu-item [routerLink]="['/propiedades/' + propiedad.id]">
              <mat-icon color="primary">edit</mat-icon>
              <span>Editar</span>
            </button>
            <button *appRole="['Propiedades.Eliminar']" mat-menu-item (click)="openDialog('Eliminar', propiedad)">
              <mat-icon color="warn">delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <!-- Definición de filas -->
      <mat-header-row *matHeaderRowDef="displayedColumns" class="tabla-header"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" class="tabla-row" matRipple></mat-row>
    </table>

    <app-sin-datos *ngIf="dataSource.data.length == 0"></app-sin-datos>
    <mat-paginator showFirstLastButtons [pageSize]="20" [hidden]=!data [pageSizeOptions]="[5, 10, 20,50,100,200]">
    </mat-paginator>
  </div>
</mat-card>
